/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import * as pendingCaseStages from "../../Stages/StagesPendingCase";
import * as caseStatus from "../../LeadStatus/StatusCase";
import * as caseStages from "../../Stages/StagesCase";
import { stageFormDefinition as stageFormDefinitionPendingCase } from "../FormDefinitions/pendingCase/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionPendingCase } from "../FormDefinitions/pendingCase/fullFormDefinition";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { getProductData } from "./productService";
import { PendingCase } from "../../../types/Products/PendingCase";
import { persistPendingCase } from "../../Persist/PersistPendingCase";
import { stageMetaDataPendingCase } from "../../Stages/StagesPendingCase";
import pendingCaseTransformations from "../FormTransformations/pendingCaseTransformations";

export const pendingCase: ProductData<PendingCase> = {
  urlPart: "vorlaeufiger-fall",
  lbUrlPart: "vorlaeufiger-fall",
  label: translate("pendingCase.label"),
  generalLabel: translate("pendingCase.label"),
  apiUri: "pending_cases",
  persist: persistPendingCase,
  stages: stageMetaDataPendingCase,
  stageConstants: pendingCaseStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\BasicCase\\PendingCase",
  formTransformations: pendingCaseTransformations,
  formDefinition: ({ product, currentUser }) => stageFormDefinitionPendingCase(product, currentUser),
  formDefinitionExternals: () => [],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionPendingCase(product, currentUser),
  caseDetailsSpecialActions: () => null,
  productCategory: "none",
  productSpecificBadges: () => [],
  caseSubBarAdditionalInformation: () => null,
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.pendingCase,
};
